// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignUpForm_Form__14rIC","FormElements":"SignUpForm_FormElements__3PYu9"};